export default {
	'no-materials-to-show': 'NO MATERIALS TO SHOW'
}